// extracted by mini-css-extract-plugin
export var resizer = "_i9-0";